import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { PATHS } from 'src-befor/app-routing.module';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MetaService {

    private routes = PATHS;
    private currentUrl = '';
    private titleBase = 'Befor Technitrans';

    constructor(private translateService: TranslateService, private router: Router, private title: Title, private meta: Meta) {
        this.watchRoute();
        this.title.setTitle(`${this.titleBase}`);
        this.meta.addTag({ name: 'description', content: this.titleBase });
    }

    private watchRoute() {
        this.router.events.pipe(
            map((res) => {
                if (res instanceof NavigationEnd) {                    
                    this.currentUrl = res.urlAfterRedirects;
                    setTimeout(() => {
                        this.setTitle();
                        this.setMeta();
                    }, 100)
                }
            })
        ).subscribe();
    }


    setTitle(forcedTitle?: string): any {
        if (forcedTitle) {
            setTimeout(() => {
                this.title.setTitle(`${this.titleBase} - ${forcedTitle}`);
                
            }, 200)
            return 0
        }
        
        let titleCustom: string;
        let urlArray = this.currentUrl.split('/');

        if (environment.languages.map(el => el.code).includes(urlArray[1])) {
            this.translateService.use(urlArray[1]);
        }

        let pathMap = new Map<string, string>(Object.entries(this.routes));

        for (let i = 0; i < urlArray.length; i++) {
            let matching_path_index = Array.from(pathMap.values()).findIndex(el => el == urlArray[i]);
            let matching_path = Array.from(pathMap.keys())[matching_path_index];

            if (matching_path?.includes('_')) {
                matching_path = matching_path.split('_')[0];
            }

            if (matching_path) {
                let key = 'Title.' + matching_path;
                this.translateService.get(key).pipe(
                    map((res) => {
                        if (res && res != key) {
                            titleCustom = res;
                        }
                    })
                ).subscribe();
            }
        }

        setTimeout(() => {
            if (titleCustom) {
                this.title.setTitle(`${this.titleBase} - ${titleCustom}`)
            } else {
                this.title.setTitle(`${this.titleBase}`)
            }
        }, 100)
    }


    setMeta(forcedMeta?: string) {
        if (forcedMeta) {
            this.meta.updateTag({ name: 'description', content: `${this.titleBase} - ${forcedMeta}` });
            return
        }

        let metaCustom: string;
        let urlArray = this.currentUrl.split('/');

        if (environment.languages.map(el => el.code).includes(urlArray[1])) {
            this.translateService.use(urlArray[1]);
        }

        let pathMap = new Map<string, string>(Object.entries(this.routes));

        for (let i = 0; i < urlArray.length; i++) {
            let matching_path_index = Array.from(pathMap.values()).findIndex(el => el == urlArray[i]);
            let matching_path = Array.from(pathMap.keys())[matching_path_index];

            if (matching_path?.includes('_')) {
                matching_path = matching_path.split('_')[0];
            }

            if (matching_path) {
                let key = 'Meta.' + matching_path;
                this.translateService.get(key).pipe(
                    map((res) => {
                        if (res && res != key) {
                            metaCustom = res;
                        }
                    })
                ).subscribe();
            }
        }

        setTimeout(() => {
            if (metaCustom) {
                this.meta.updateTag({ name: 'description', content: `${this.titleBase} - ${metaCustom}` });
            } else {
                this.meta.updateTag({ name: 'description', content: `${this.titleBase}` });
            }
        }, 100)
    }
}
